var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".75vw",
    height: ".6vw",
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20038 6.93701C1.01905 6.68834 0.928381 6.56368 0.865714 6.32368C0.823408 6.10997 0.823408 5.89005 0.865714 5.67634C0.928381 5.43568 1.01905 5.31101 1.20038 5.06301C2.19305 3.69968 4.36905 1.33301 7.50038 1.33301C10.6317 1.33301 12.8077 3.69968 13.8004 5.06234C13.9817 5.31101 14.0724 5.43568 14.135 5.67568C14.1774 5.88938 14.1774 6.1093 14.135 6.32301C14.0724 6.56368 13.9817 6.68834 13.8004 6.93634C12.8077 8.29968 10.6317 10.6663 7.50038 10.6663C4.36905 10.6663 2.19305 8.29968 1.20038 6.93701Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 7.33268C7.85395 7.33268 8.19309 7.19221 8.44313 6.94216C8.69318 6.69211 8.83366 6.35297 8.83366 5.99935C8.83366 5.64573 8.69318 5.30659 8.44313 5.05654C8.19309 4.80649 7.85395 4.66602 7.50033 4.66602C7.1467 4.66602 6.80757 4.80649 6.55752 5.05654C6.30747 5.30659 6.16699 5.64573 6.16699 5.99935C6.16699 6.35297 6.30747 6.69211 6.55752 6.94216C6.80757 7.19221 7.1467 7.33268 7.50033 7.33268Z",
    stroke: "#FCFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.eb6d3fbc690b4c00a5b029314a5aa208.svg";
export { ForwardRef as ReactComponent };